import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { IUser, UserActionTypes } from "../models";
import { GOOGLE_LOGIN } from "../types";

export default (data: { accessToken: string, lang: string }) =>
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    dispatch({
        type: GOOGLE_LOGIN,
        payload: {
            loading: true,
        },
    });
    try {
        const res = await api.post<{ user: IUser, success: boolean }>("/google-login", data);
        dispatch({
            type: GOOGLE_LOGIN,
            payload: res,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        dispatch({
            type: GOOGLE_LOGIN,
            payload: {
                error: true,
            },
        });
    }
};
